import { ICON_BUTTON } from "./styles";

const formatNumber = (value) => value.toLocaleString("pt-BR");

const Pagination = ({ table }) => {
    const { pageIndex, pageSize } = table.getState().pagination;
    const total = table.getFilteredRowModel().rows.length;
    if (total === 0) return null;
    const first = pageIndex * pageSize + 1;
    const last = Math.min(total, first + pageSize - 1);
    return (
        <nav aria-label="Paginação" className="flex items-center justify-end gap-2 px-2 py-2 text-sm text-laranjinha/80">
            <span>{`${formatNumber(first)}–${formatNumber(last)} de ${formatNumber(total)}`}</span>
            <button type="button" className={ICON_BUTTON} aria-label="Primeira página" onClick={() => table.setPageIndex(0)} disabled={!table.getCanPreviousPage()}>«</button>
            <button type="button" className={ICON_BUTTON} aria-label="Página anterior" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>‹</button>
            <span>{`Página ${pageIndex + 1} de ${table.getPageCount()}`}</span>
            <button type="button" className={ICON_BUTTON} aria-label="Próxima página" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>›</button>
            <button type="button" className={ICON_BUTTON} aria-label="Última página" onClick={() => table.setPageIndex(table.getPageCount() - 1)} disabled={!table.getCanNextPage()}>»</button>
        </nav>
    );
};

export default Pagination;
